import React from 'react';
import ContentArea from "../components/content-area/Content";
import ComingSoonPage from "../components/homepage/ComingSoonPage";
import LightningIconPng from "../assets/icons/lightning.png";

const Lighting = () => (
  <ContentArea title="Lighting" icon={LightningIconPng} container={false}>
    <ComingSoonPage />
  </ContentArea>
);

export default Lighting;
